import React from 'react';
import { useNavigate } from "react-router-dom";
import { MapPin, User } from 'lucide-react';


interface ApartmentCardProps {
  id: number;
  name: string[];
  description: string[];
  location: { location: string };
  mainFacts: string[];
  featured: boolean;
  price: number;
  apartmentImages: string[];
  language: string;
  ApartmentName: string;
  t: { apartmentFrom: string; apartmentPrice: string; apartmentFeature: string };
}
export function ApartmentCard({ name, ApartmentName, location, price, featured, language, t, apartmentImages }: ApartmentCardProps) {
  const navigate = useNavigate();
  const handleClick = () => {
    window.scrollTo(0,0)
    navigate(`/apartment/${encodeURIComponent(ApartmentName)}`, {
      state: {
        apartmentImages,
        language,
        t,
      },
    });
  };
  return (
    <div onClick={handleClick}

      className={`grid apartment-card max-w-[310px] min-w-[280px] h-[450px]
      rounded-xl overflow-hidden shadow-lg transition-transform duration-300 hover:-translate-y-2
      ${featured ? 'border-2 border-[--c-accent]' : ''}
    `}>
      <div className="relative">
        <div
          style={{
            backgroundImage: apartmentImages?.[0] ? `url(${apartmentImages[0]})` : 'none',
          }}
          className="w-full h-64 object-cover bg-bottom bg-cover"
        >
        </div>

        {featured && (
          <div className="absolute top-4 right-4 bg-[--c-accent] text-[--c-dark] px-3 py-1 rounded-full text-sm font-semibold ">
            {t.apartmentFeature}
          </div>
        )}
      </div>
      <div className="p-3 grid items-start">
        <h3 className="text-2xl font-semibold mb-2 text-[--c-dark]">{name[language]} </h3>
        <div className="flex items-center gap-2 text-[--c-second] mb-4 text-xl">
          <MapPin size={16} />
          <span>{location.location}</span>
        </div>

        {price && (
          <div className="text-right">
            <span className="text-sm text-[--c-second]">{t.apartmentFrom}</span>
            <p className="text-xl font-bold text-[--c-main] flex justify-between"><span className='flex'>
              {name['sr'] === 'Bella Studio' ? "2-3" : "4" } 
              <User /></span>&euro;{price}/{t.apartmentPrice}</p>
          </div>
        )}
      </div>
    </div>
  );
}
